import type * as React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router";
import { TooltipProvider } from "@moanhot/ui";
import { NAV } from "@/nav";
import { Shell } from "@/screens/Shell";
import { Empty } from "@/screens/Empty";
import { SignIn } from "@/screens/SignIn";
import { Applications } from "@/screens/Applications";
import { TenantsRunpod } from "@/screens/TenantsRunpod";
import { Tenants } from "@/screens/Tenants";
import { Prices } from "@/screens/Prices";
import { Catalogue } from "@/screens/Catalogue";
import { Screening } from "@/screens/Screening";
import { WebhookHealth } from "@/screens/WebhookHealth";
import { Reconciliation } from "@/screens/Reconciliation";
import { Audit } from "@/screens/Audit";
import type { NavKey } from "@/nav";

const SCREENS: Partial<Record<NavKey, () => React.JSX.Element>> = {
  applications: Applications,
  tenants: Tenants,
  prices: Prices,
  catalogue: Catalogue,
  screening: Screening,
  webhooks: WebhookHealth,
  reconciliation: Reconciliation,
  runpod: TenantsRunpod,
  audit: Audit,
};

function Layout() {
  return (
    <Shell>
      <Outlet />
    </Shell>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="signin" element={<SignIn />} />
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/applications" replace />} />
        {NAV.map((n) => {
          const Screen = SCREENS[n.key];
          return <Route key={n.key} path={n.path.slice(1)} element={Screen ? <Screen /> : <Empty title={n.label} job={n.job} />} />;
        })}
        <Route path="*" element={<Empty title="Not found" job="This page does not exist. Pick a screen from the sidebar." />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <TooltipProvider>
      <AppRoutes />
    </TooltipProvider>
  );
}
